export default function Footer() {
	return (
		<footer className="bg-neutral-200 dark:bg-inherit text-neutral-900 dark:text-inherit dark:border-t dark:border-neutral-100 py-4 text-center">
	      Made with <span className="text-red-600">❤</span> by <a href="https://twitter.com/c0boi" className="hover:underline" target="_blank" rel="noreferrer">coboi</a>
	    </footer>
	)
}